import styled from 'styled-components';
import { theme } from '@octane/spark';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Title = styled.h1`
  font-family: 'Oswald', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
`;

export const Payment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0px;
  padding: 10px;
  background-color:${({ theme }) => theme.colors.monochrome.moonGrey};
  border-radius: 5px;
  box-shadow: ${({ theme }) => theme.shadows.tile};
`;

export const PaymentTitle = styled.h2`
  ${theme.fonts.Karla['s16-ln20-fw400']};
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.monochrome.ravenSub};
`;

export const PaymentAmount = styled.h3`
  font-family: 'Oswald', sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
`;
